import styled from 'styled-components';
import EasyBookingSvg from '../../../assets/onboardingNew/homepage/easy-booking.svg';

const EasyBookingNewIcon = styled(EasyBookingSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2rem'};
height: ${props => props.height || '2rem'};
display: flex;
`;

export default EasyBookingNewIcon;
